//DESA
//export const WEB_AUTH_URL = import.meta.env.VITE_WEB_AUTH_URL || "http://localhost:8081";
//export const WEB_CORE_URL = import.meta.env.VITE_WEB_CORE_URL || "http://localhost:3000";
//export const PARAM_NAME_COOKIEDOMAIN = import.meta.env.VITE_PARAM_NAME_COOKIEDOMAIN || "localhost";


//QA GATEWAY
export const WEB_AUTH_URL = "https://auth.qasg3plus.com";
export const WEB_CORE_URL = "https://qasg3plus.com";
export const PARAM_NAME_COOKIEDOMAIN = ".qasg3plus.com";

//PRD
//export const WEB_AUTH_URL = "https://auth.sg3plus.com";
//export const WEB_CORE_URL = "https://sg3plus.com";
//export const PARAM_NAME_COOKIEDOMAIN = ".sg3plus.com";

//export const URL_SSO_SG3LEGACY = "_layouts/15/imagen.Tripontis.SG3/Login.aspx";




//export const API_CORE_SERVICE_URL = "https://localhost:44382";
export const API_CORE_SERVICE_URL = "https://qa-sg3plus-api-core.azurewebsites.net";
//export const API_CORE_SERVICE_URL = "https://sg3plus-api-core.azurewebsites.net";